<div class="title">Турниры</div>
<div class="filters">
  <div class="item">
    <mtg-dropdown
      label="Сезон"
      [formControl]="seasonControl"
    >
      <mtg-dropdown-item>Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let season of seasons"
        [value]="season.id"
      >{{ season.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>
  <div class="item">
    <mtg-text-field
      label="Поиск"
      [formControl]="searchControl"
    ></mtg-text-field>
  </div>
</div>
<ng-container *ngFor="let season of seasons">
  <div class="season" *ngIf="tournamentsBySeason[season.id] && tournamentsBySeason[season.id].length > 0">
    <div class="name" *ngIf="false">{{ season.name }}</div>
    <div class="tournaments">
      <ng-container *ngFor="let tournament of tournamentsBySeason[season.id]">
        <ng-container *ngIf="tournament.settings.type !== tournamentTypes.fiba">
          <mtg-league-galo-tournament-card
            *ngIf="isGaloTournament(tournament.id)"
            [tournament]="tournament"
          ></mtg-league-galo-tournament-card>
          <mtg-league-tournament-card
            *ngIf="!isGaloTournament(tournament.id) && tournament.status === tournamentStatuses.closed"
            [tournament]="tournament"
          ></mtg-league-tournament-card>
          <mtg-tournament-widget
            *ngIf="!isGaloTournament(tournament.id) && tournament.status !== tournamentStatuses.closed"
            [tournament]="tournament"
          ></mtg-tournament-widget>
        </ng-container>
        <mtg-tournament-stage-widget
          *ngIf="tournament.status !== tournamentStatuses.closed && tournament.settings.type === tournamentTypes.fiba"
          [tournament]="tournament"
        ></mtg-tournament-stage-widget>
      </ng-container>
    </div>
  </div>
</ng-container>
<mtg-league-about-block></mtg-league-about-block>
